import { CreditCardInfo } from 'store/client/client.types';
import { CREDIT_CARD_ID_NONE } from './constants';

export const getInitCreditCardIds = (creditCards: CreditCardInfo[], addedCardId: string | null = null) => {
  if (addedCardId && creditCards.some((creditCard) => creditCard.creditCardId === addedCardId)) {
    return addedCardId;
  }
  const defaultSelectedCard =
    creditCards.find((creditCard) => creditCard.isDefault)?.creditCardId || CREDIT_CARD_ID_NONE;
  return defaultSelectedCard;
};
